import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import {validatable} from 'components/utils';
import { DuLieuHeThong } from 'api';

class DropDownChonDonViThongKe extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getDonViThongKe.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'donViThongKe',
            data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    const dataOptions = this.props.isAll ? [{coQuanQuanLyId: 0, ten: 'Chọn tất cả'}, ...this.state.data] : [...this.state.data];

    return (
      <DropDown disabled={this.props.disabled} label={this.props.label} bindValidator={this} channel="formTaoDon" selectedValue={this.props.selectedValue} require={this.props.require} isValid={this.props.isValid} options={dataOptions} keyName='coQuanQuanLyId' valueName='ten' onChange={this.onChange.bind(this)} placeholder={this.props.placeholder} className={'col-input '+this.props.className} name={this.props.name}/>
    )
  }
}

DropDownChonDonViThongKe.defaultProps = {
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  name:'',
  label: 'Đơn vị',
  data: [],
  disabled: false
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.donViThongKe
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonDonViThongKe));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chondonvithongke.jsx